<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <blockquote :style="(this.$vuetify.theme.dark ? 'color:lightgrey' : 'color:darkslategrey')" class="blockquote">Drag and drop or click to upload files on the left OR paste/type text or images into the text editor on the right.</blockquote>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab" grow background-color="grey lighten-3">
            <v-tab key="upload" style="border-right:solid 1px darkslategrey">
              Upload
            </v-tab>
            <v-tab key="edit">
              Paste/Type
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item key="upload">
              <vue-dropzone ref="myVueDropzone" @vdropzone-file-added="fileadded" :class="(this.$vuetify.theme.dark ? 'dropzone-dark' : '')" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
            </v-tab-item>
            <v-tab-item key="edit" style="border: 2px solid lightgrey;padding: 10px 20px 30px;">
              <v-text-field
                label="Filename"
                v-model="filename"
                outlined
                dense
                suffix=".html"
                class="mt-2"
              ></v-text-field>
              <vue-editor ref="vEditor" style="height:285px;padding-bottom:20px;margin-bottom:20px;" v-model="content" :editorToolbar="customToolbar"></vue-editor>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
      <v-row v-if="tab==1">
        <v-col cols="12">
          <v-btn block color="success" @click="uploadText">Upload File</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-divider :style="'margin-top: 15px;border-color:' + (this.$vuetify.theme.dark ? 'white' : 'black')"></v-divider>
      </v-row>
      <v-row>
        <v-col cols="12">
          <blockquote :style="(this.$vuetify.theme.dark ? 'color:lightgrey' : 'color:darkslategrey')" class="blockquote">Use the copy button below to copy and paste the links/passwords into the Jira ticket.</blockquote>
        </v-col>
      </v-row>
      <v-row class="mb-2">
        <v-col cols="12">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">Filename</th>
                <th class="text-center">Link</th>
                <th class="text-center">Password</th>
                <th class="text-center">Copy</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in links" :key="item.name">
                <td class="text-left">{{ item.name }}</td>
                <td class="text-left">{{ item.url }}</td>
                <td>{{ item.password }}</td>
                <td>
                  <v-btn v-clipboard="item.copy" class="mx-2" dark x-small color="primary">
                    Copy Link/Password                  
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn @click="copyAll" block color="primary">Copy All Links/Passwords</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'upload',
  props: {
    msg: String
  },
  data: function () {
    return {
      dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 100,
          thumbnailHeight: 100,
          maxFilesize: 0.5,
          headers: { "My-Awesome-Header": "header value" }
      },
      content: null,
      customToolbar:[[{ 'size': [] }],["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [ { 'align': [] }],[ 'link' ]],
      value: "Paste something different",
      tab:0,
      filename:null,
      links: [],
    }
  },
  methods: {
    copyAll(){
      let out="", links = this.links;
      for(let l=0; l<links.length; l++){
        out += links[l].copy + "\r\n";
      }
      this.$clipboard(out);
    },
    sendFile(pload){
      let t = this;
      axios.post('https://bo0ntxkmv5.execute-api.us-east-1.amazonaws.com/prod/upload',pload)
        .then(function(res){
          console.log(res);
          t.links.push({
            name: res.data.filename,
            url: 'https://secureit.care/' + res.data.uuid,
            password: res.data.password,
            copy: res.data.filename + " | " + 'https://secureit.care/' + res.data.uuid + " | " + res.data.password
          })
        })
        .catch(function(err){
          console.log(err);
        })
    },
    uploadText(){
      this.sendFile({
        filename: this.filename + ".html",
        file: this.content,
        //file: this.$refs.vEditor.quill.getContents(),
        texteditor: true
      })
    },
    fileadded(file){
      console.log(file);
      let t = this;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(event){
        t.sendFile({
          file: event.target.result.split(",").pop(),
          filename: file.name,
          mimetype: file.type,
          texteditor: false
        });
      }
    }
  }
}
</script>
<style>
  .v-heading {
    font-size: 3em;
  }
  .sepText {
    position: absolute;
    margin-top: -68px;
    left: 47%;
    background-color: #fff;
    padding: 8px;
  }
  .or-separator {
    margin-left: 20%;
    margin-right: 20%;
  }
  #dropzone{
    height: 420px;
     padding: 40px;
     overflow-y:scroll;
     overflow-x:none;
  }
  #dropzone .dz-message{
    margin: 150px 0;
  }
  .dropzone-dark {
    background-color: #1e1e1e;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: white;
    transition: background-color .2s linear;
    border: 1px solid white !important;
  }

  .dropzone-dark .dz-preview {
    width: 80px;
    display: inline-block
  }
  .dropzone-dark .dz-preview .dz-image {
    width: 40px !important;
    height: 20px !important;
    margin-left: 20px !important;
    margin-bottom: 10px !important;
  }
  .dropzone-dark .dz-preview .dz-image > div {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background-size: contain;
  }
  .dropzone-dark .dz-preview .dz-image > img {
    width: 100%;
  }

  .dropzone-dark .dz-preview .dz-details {
    color: white;
    transition: opacity .2s linear;
    text-align: center;
  }
  .dropzone-dark .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
</style>
